window.poojiDateGlobalConfig = {
    "availableDays": {
        "monday": true,
        "tuesday": true,
        "wednesday": true,
        "thursday": true,
        "friday": true,
        "saturday": true,
        "sunday": true
    },
    "blockPositioningEnabled": true,
    "dynamicBlock": true,
    "blockedDates": [],
    "textContent": {
        "app.block.save": "Save",
        "shop.money_with_currency_format": "${{amount}} USD",
        "shop.money_format": "${{amount}}",
        "input.placeholder": "Select a date",
        "shipping.profile.delivery_days": "Delivery available",
        "property.estimated_delivery_label": "Delivery Date",
        "property.estimated_time_label": "Time Slot",
        "time.slot.label": "Select a time slot"
    },
    "cutoffConfigs": {
        "cutOffHour": 21,
        "cutOffMinute": 0,
    },
    "minimumDaysAhead": 1,
    "maximumDaysAhead": 90,
    "autoSelectEarliestDate": true,
    "blockCheckoutWithoutDate": true,
    "localPickup": {
        "enabled": true,
        "timeWindows": [
            {
                "id": "1752722997568",
                "start": "07:00",
                "end": "23:59"
            }
        ],
        "timeSlots": [{
            "label": "As Soon As Possible",
            "start": "07:00",
            "end": "23:59",
            "cutOff": "23:59"
        },{
            "label": "6:00 AM - 9:00 AM",
            "start": "06:00",
            "end": "09:00",
            "cutOff": "08:00"
        },{
            "label": "7:00 AM - 10:00 AM",
            "start": "07:00",
            "end": "10:00",
            "cutOff": "09:00"
        },{
            "label": "8:00 AM - 11:00 AM",
            "start": "08:00",
            "end": "11:00",
            "cutOff": "10:00"
        }, {
            "label": "9:00 AM - 12:00 PM",
            "start": "09:00",
            "end": "12:00",
            "cutOff": "11:00"
        },{
            "label": "10:00 AM - 1:00 PM",
            "start": "10:00",
            "end": "13:00",
            "cutOff": "12:00"
        }, {
            "label": "11:00 AM - 2:00 PM",
            "start": "11:00",
            "end": "14:00",
            "cutOff": "13:00"
        },{
            "label": "12:00 PM - 3:00 PM",
            "start": "12:00",
            "end": "15:00",
            "cutOff": "14:00"
        }, {
            "label": "1:00 PM - 4:00 PM",
            "start": "13:00",
            "end": "16:00",
            "cutOff": "15:00" 
        },{
            "label": "2:00 PM - 5:00 PM",
            "start": "14:00",
            "end": "17:00",
            "cutOff": "16:00" 
        }, {
            "label": "3:00 PM - 6:00 PM",
            "start": "15:00",
            "end": "18:00",
            "cutOff": "17:00" 
        },{
            "label": "4:00 PM - 7:00 PM",
            "start": "16:00",
            "end": "19:00",
            "cutOff": "18:00" 
        }, {
            "label": "5:00 PM - 8:00 PM",
            "start": "17:00",
            "end": "20:00",
            "cutOff": "19:00"
        }, {
            "label": "6:00 PM - 9:00 PM",
            "start": "18:00",
            "end": "21:00",
            "cutOff": "20:00"
        },{
            "label": "7:00 PM - 10:00 PM",
            "start": "19:00",
            "end": "22:00",
            "cutOff": "21:00"
        },{
            "label": "8:00 PM - 11:00 PM",
            "start": "20:00",
            "end": "23:00",
            "cutOff": "22:00"
        },{
            "label": "9:00 PM - 12:00 PM",
            "start": "21:00",
            "end": "00:00",
            "cutOff": "22:00"
        }],
        "defaultTimeSlot": "As Soon As Possible",
        "slotDuration": 180,
        "cutOff": "22:00"
    }
};

const APP_CART_UPDATE = 'APP_CART_UPDATE';
let isProcessingCartUpdate = false;
let hasSavedInitialBlock = false; // Flag to ensure savedBlockHtml is captured only once

// Create an interceptor for fetch calls
const originalFetch = window.fetch;
window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0].url;
    const options = args[1] || {};

    // Check if this is a GraphQL cart query
    if (url.includes('/graphql.json') &&
        (url.includes('cartQuery') ||
            (options.body && options.body.includes('cartQuery')))) {

        console.log('🔄 Intercepted GraphQL cart query, queueing...');
        return cartOperationQueue.enqueue(() => originalFetch.apply(this, args));
    }

    // Check if this is any cart-related endpoint (with and without .js)
    if (url.includes('/cart/update') ||
        url.includes('/cart/change') ||
        url.includes('/cart/add') ||
        url.includes('/cart/clear')) {  // Also watching for cart clear

        // Check if this request originated from our code
        const isPoojiRequest = options.headers &&
            options.headers['X-Pooji-Request'] === APP_CART_UPDATE;

        // Add check for mincart request
        const isMinicartRequest = url.includes('mincart-request=true');

        if (!isPoojiRequest) {
            if (!isMinicartRequest) {
                console.log('🔍 Intercepted non-Pooji cart operation:', url);
            }
        } else {
            console.log('✨ Intercepted Pooji cart operation:', url);
        }

        return originalFetch.apply(this, args)
            .then(async response => {
                if (!isPoojiRequest && !isMinicartRequest && !isProcessingCartUpdate) {
                    console.log('🔄 External cart update detected!!');
                    isProcessingCartUpdate = true;

                    try {
                        // Update the currentCart in poojiDateGlobalConfig with the latest cart data
                        const cartData = await response.clone().json();
                        window.poojiDateGlobalConfig.currentCart = cartData.items || [];

                        // Wait for DOM to update
                        setTimeout(async () => {
                            if(cartData.total_price <= 0) {
                                console.log('🛒 Cart is empty, skipping block positioning.');
                                //isBlockPositioned = false; // Reset positioning state
                                isProcessingCartUpdate = false;
                                sessionStorage.removeItem('deliveryDate');
                                sessionStorage.removeItem('timeSlot');
                                return;
                            }
                            document.dispatchEvent(new Event('DOMContentLoaded'));
                            isProcessingCartUpdate = false;
                        }, 500);
                    } catch (error) {
                        console.error('Error processing cart update:', error);
                        isProcessingCartUpdate = false;
                    }
                }
                return response;
            });
    }

    return originalFetch.apply(this, args);
};

function formatDateForLogs(date) {
    if (!date || !(date instanceof Date) || isNaN(date)) {
        return 'Invalid Date';
    }

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return `${days[date.getDay()]} ${months[date.getMonth()]} ${date.getDate()} ${date.getFullYear()}`;
}

function isCutoffPassed(relevantDate) {
    return false;
}

const cartOperationQueue = {
    promise: Promise.resolve(),
    enqueue: function (operation) {
        return this.promise = this.promise
            .then(() => operation())
            .catch(error => {
                console.error('🚨 Cart operation failed:', error);
                throw error;
            });
    }
};

async function updateCartItems() {
    console.log('🎬 Starting updateCartItems');
    const checkoutButtons = document.querySelectorAll('button[name="checkout"], input[name="checkout"], [form="cart"][name="checkout"], button#cart-checkout[data-href="/checkout"]');
    const originalDisplayStates = new Map();
    const datePickerLoading = document.querySelector('#date-picker-loading');
    const dateSelector = document.querySelector('.date-selector');
    const shipDate = document.querySelector('#ship-date');
    const timeSlotSelect = document.getElementById('time-slot-select');
    const dynamicCheckoutContainer = document.querySelector('.dynamic-checkout__content');

    // Disable all checkout buttons initially
    checkoutButtons.forEach(button => {
        button.style.opacity = '0.5';
        button.style.pointerEvents = 'none';
    });

    // Also hide dynamic checkout buttons initially
    if (dynamicCheckoutContainer) {
        dynamicCheckoutContainer.classList.remove('pooji-show');
    }

    return cartOperationQueue.enqueue(async () => {
        try {
            const deliveryDate = new Date(document.querySelector('#ship-date').dataset.deliveryDate);
            const timeSlot = document.getElementById('time-slot-select')?.value || null;
            console.log('📦 Delivery date:', deliveryDate);
            const deliveryDateStr = deliveryDate.toLocaleDateString('en-US', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
            
            // Update cart attributes with simple date strings
            const attributesToUpdate = {
                'delivery_date': deliveryDateStr,
                'deliver_time_slot': timeSlot
            };
            deliveryDate && sessionStorage.setItem('deliveryDate', deliveryDate);
            timeSlot && sessionStorage.setItem('timeSlot', timeSlot);
            
            const updatedCart = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Pooji-Request': APP_CART_UPDATE
                },
                body: JSON.stringify({
                    attributes: attributesToUpdate
                })
            }).then(res => res.json());

            // Format the delivery date once for all items
            // Use Shopify.locale for proper localization, fallback to 'en'
            let displayLocale = 'en';
            const formattedDeliveryDate = deliveryDate.toLocaleDateString(displayLocale, {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });

            // Update line item properties
            for (const item of updatedCart.items) {
                const propertyKeyDelivery = window.poojiDateGlobalConfig.textContent["property.estimated_delivery_label"];
                const propertyKeyTimeSlot = window.poojiDateGlobalConfig.textContent["property.estimated_time_label"];; // Use hardcoded label "Time"

                let propertiesToUpdate = { ...item.properties }; // Start with existing properties

                // Always add formatted time slot if enabled and selected
               // propertiesToUpdate[propertyKeyDelivery] = formattedDeliveryDate;
                //propertiesToUpdate[propertyKeyTimeSlot] = timeSlot; 
                        
                // Also add the hidden property in fallback
                propertiesToUpdate['__pooji_delivery_time_slot'] = timeSlot;
                propertiesToUpdate['__pooji_delivery_date'] = formattedDeliveryDate;

                // Check if any properties actually changed before sending update
                // Compare keys and values for a more robust check
                const originalKeys = Object.keys(item.properties || {});
                const updatedKeys = Object.keys(propertiesToUpdate);
                const propertiesChanged = originalKeys.length !== updatedKeys.length || 
                    updatedKeys.some(key => !item.properties || propertiesToUpdate[key] !== item.properties[key]);


                if (propertiesChanged) {
                    console.log(`🔄 Updating properties for item key: ${item.key}`, propertiesToUpdate);
                    await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Pooji-Request': APP_CART_UPDATE
                        },
                        body: JSON.stringify({
                            id: item.key,
                            quantity: item.quantity,
                            properties: propertiesToUpdate
                        })
                    });
                } else {
                     console.log(`ℹ️ No property changes needed for item key: ${item.key}`);
                }
            }

            console.log('✅ Cart successfully updated');

            document.dispatchEvent(new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { cart: updatedCart }
            }));

            return updatedCart;

        } catch (error) {
            console.error('🚨 Error updating cart:', error);
            throw error;
        } finally {
            console.log('✅ Restoring checkout button visibility');
            
            const hasTimeSlot = timeSlotSelect?.value;
            const shouldEnableButtons = hasTimeSlot;

            const checkoutButtonsNew = document.querySelectorAll('button[name="checkout"], input[name="checkout"], [form="cart"][name="checkout"], button#cart-checkout[data-href="/checkout"]');
            
            checkoutButtonsNew.forEach(button => {
                button.style.opacity = shouldEnableButtons ? '1' : '0.5';
                button.style.pointerEvents = shouldEnableButtons ? 'auto' : 'none';
            });

            if (dynamicCheckoutContainer) {
                if (shouldEnableButtons) {
                    dynamicCheckoutContainer.classList.add('pooji-show');
                } else {
                    dynamicCheckoutContainer.classList.remove('pooji-show');
                }
            }
        }
    });
}

function formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

document.addEventListener('DOMContentLoaded', async function () {
      // Select the target element to observe.
  const targetElement = document.querySelector('.delivery-time-slot-block');

  // Check if the target element exists.
  if (!targetElement) {
    console.log("Error: Target element with class 'delivery-time-slot-block' not found.");
    return;
  }
      /**
   * The callback function to be executed when mutations are observed.
   * @param {MutationRecord[]} mutationsList - A list of MutationRecord objects.
   * @param {MutationObserver} observer - The observer instance that triggered the callback.
   */
  const observerCallback = (mutationsList, observer) => {
    // Loop through all observed mutations.
    for (const mutation of mutationsList) {
      // Check if the mutation was an attribute change, specifically the 'class' attribute.
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // Get the current list of classes for the target element.
        const classList = mutation.target.classList;

        // Check if the element has the required class but is missing the 'pooji-initialized' class.
        if (classList.contains('delivery-time-slot-block') && !classList.contains('pooji-initialized')) {
          console.log("The 'delivery-time-slot-block' element does not have the 'pooji-initialized' class.");
          // Optionally, you can disconnect the observer after the first log if you only need a one-time check.
          // observer.disconnect();
            if (flatpickrInstance) {
                flatpickrInstance.destroy();
                initializeDatePicker();
            }
        }
      }
    }
  };

  // Create a new instance of MutationObserver with the callback function.
  const observer = new MutationObserver(observerCallback);

  // Define the observer's configuration.
  // We want to observe for changes to the element's attributes.
  // We use attributeFilter to only trigger the callback for changes to the 'class' attribute.
  const config = { attributes: true, attributeFilter: ['class'] };

  // Start observing the target element with the defined configuration.
  observer.observe(targetElement, config);

  // --- Example to demonstrate the observer in action ---
  // You can remove this section in your actual application.
  console.log("Observer is running. Simulating class changes...");
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            const shipDateInput = document.querySelector('#ship-date');
            if (shipDateInput) shipDateInput.value = '';

            const dateSelector = document.querySelector('#date-selector-wrapper');
            const dateSelectorLabel = document.querySelector('.date-selector-label');

            //if (dateSelector) dateSelector.style.display = 'none';
            //if (dateSelectorLabel) dateSelectorLabel.style.display = 'none';

            const checkoutButtons = document.querySelectorAll('button[name="checkout"], input[name="checkout"], [form="cart"][name="checkout"], button#cart-checkout[data-href="/checkout"]');

            const dropdownArrow = document.querySelector('.date-dropdown-arrow');
            if (dropdownArrow) dropdownArrow.classList.remove('hidden');
            console.log('📅 No shipping zones - showing date selector on BFCache restore');
            if (dateSelector) dateSelector.style.display = 'flex';
            if (dateSelectorLabel) dateSelectorLabel.style.display = 'flex';

            if (flatpickrInstance) {
                flatpickrInstance.destroy();
                initializeDatePicker();
            }
            return;
        }
    });

    const shipDateInput = document.querySelector('#ship-date');
    const dateSelector = document.querySelector('#date-selector-wrapper');
    const dateSelectorLabel = document.querySelector('.date-selector-label');
    let flatpickrInstance = null;

    const checkoutButtons = document.querySelectorAll('button[name="checkout"], input[name="checkout"], [form="cart"][name="checkout"], button#cart-checkout[data-href="/checkout"]');

    if (dateSelector) {
        dateSelector.classList.remove('enabled');
    }
    if (dateSelectorLabel) {
        dateSelectorLabel.classList.remove('enabled');
    }

    if (dateSelector) {
        dateSelector.addEventListener('click', function () {
            document.querySelector('#ship-date').focus();
        });
    }

    function formatDateToYYYYMMDD(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    function initializeTimeSlots() {
        const timeSlotContainer = document.getElementById('time-slot-container');
        const timeSlotSelect = document.getElementById('time-slot-select');

        if(timeSlotContainer) timeSlotContainer.style.display = 'flex';

        if(timeSlotSelect) {
            timeSlotSelect.addEventListener('change', function () {
                const checkoutButtons = document.querySelectorAll('button[name="checkout"], input[name="checkout"], [form="cart"][name="checkout"], button#cart-checkout[data-href="/checkout"]');

                checkoutButtons.forEach(button => {
                    button.style.opacity = '1';
                    button.style.pointerEvents = 'auto';
                });

                updateCartItems();
            });
        }
    }

    function isLaterThanLatestEarliestAvailableDate(date) {
        const allEarliestDatesInCart = [];
        
        if (allEarliestDatesInCart.length === 0) {
            return true; 
        }

        const latestEarliestDate = new Date(Math.max.apply(null, allEarliestDatesInCart));
        const candidateDateUTCNoon = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0));
        const result = candidateDateUTCNoon >= latestEarliestDate;
        
        return result;
    }

    function getMinimumDate() {
        const now = new Date();
        const kuwaitParts = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Kuwait',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).formatToParts(now);
        const kuwaitYear = parseInt(kuwaitParts.find(part => part.type === 'year').value, 10);
        const kuwaitMonth = parseInt(kuwaitParts.find(part => part.type === 'month').value, 10) - 1;
        const kuwaitDay = parseInt(kuwaitParts.find(part => part.type === 'day').value, 10);
        const initialDate = new Date(kuwaitYear, kuwaitMonth, kuwaitDay);
        let candidateDate;
        // const now = new Date();
        // const options = {
        // hour: 'numeric',
        // hour12: false,
        // timeZone: 'Asia/Kuwait'
        // };

        // const kuwaitTime = now.toLocaleString('en-US', options);
        // const {cutOffHour, cutOffMinute} = window.poojiDateGlobalConfig.cutoffConfigs;
        // // Choose increment based on cutoff
        // const incr = parseInt(kuwaitTime) > cutOffHour ? 1 : 0;
        candidateDate = initialDate.fp_incr(0);
        const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

        while (true) {
            const dayName = dayNames[candidateDate.getDay()];
            const isDayAvailable = window.poojiDateGlobalConfig.availableDays[dayName];

            const isBlocked = isDateBlocked(candidateDate, null);

            let isCutoffPassedBool = false;
            isCutoffPassedBool = isCutoffPassed(candidateDate);

            const isDateLaterThanEarliestAvailableDate = isLaterThanLatestEarliestAvailableDate(candidateDate);

            if (isDayAvailable && !isBlocked && !isCutoffPassedBool && isDateLaterThanEarliestAvailableDate) {
                break;
            }

            candidateDate.setDate(candidateDate.getDate() + 1);
        }

        return candidateDate;
    }

    function getLatestPossibleDate() {
        const today = new Date();
        const result = today.fp_incr(365);
        return result;
    }

    const localeObject = (function () {
        const locale = 'en';
        console.log('🌍 Setting up locale:', locale);

        let localeObj;
        switch (locale) {
            case "fr":
                localeObj = flatpickr.l10ns.fr;
                break;
            case "pt-BR":
                localeObj = flatpickr.l10ns.pt;
                break;
            case "pt-PT":
                localeObj = flatpickr.l10ns.pt;
                break;
            case "de":
                localeObj = flatpickr.l10ns.de;
                break;
            case "es":
                localeObj = flatpickr.l10ns.es;
                break;
            case "lt":
                localeObj = flatpickr.l10ns.lt;
                break;
            case "it":
                localeObj = flatpickr.l10ns.it;
                break;
            case "nl":
                localeObj = flatpickr.l10ns.nl;
                break;
            case "ja":
                localeObj = flatpickr.l10ns.ja;
                break;
            case "zh":
            case "zh-CN":
                localeObj = flatpickr.l10ns.zh;
                break;
            case "zh-TW":
                localeObj = flatpickr.l10ns.zh_tw || flatpickr.l10ns.zh;
                break;
            case "ko":
                localeObj = flatpickr.l10ns.ko;
                break;
            case "da":
                localeObj = flatpickr.l10ns.da;
                break;
            case "sv":
                localeObj = flatpickr.l10ns.sv;
                break;
            case "no":
            case "nb":
            case "nn":
                localeObj = flatpickr.l10ns.no;
                break;
            case "fi":
                localeObj = flatpickr.l10ns.fi;
                break;
            case "pl":
                localeObj = flatpickr.l10ns.pl;
                break;
            case "cs":
                localeObj = flatpickr.l10ns.cs;
                break;
            case "tr":
                localeObj = flatpickr.l10ns.tr;
                break;
            default:
                localeObj = flatpickr.l10ns.default;
                break;
        }
        
        localeObj.firstDayOfWeek = 1;
        console.log('📅 Setting Monday as first day of week for all locales');
        
        return localeObj;
    })();

    function isSameDay(date1, date2) {
        const toKuwaitYMD = (date) => {
            const parts = new Intl.DateTimeFormat('en-CA', {
                timeZone: 'Asia/Kuwait',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).formatToParts(date);
            const year = parseInt(parts.find(part => part.type === 'year').value, 10);
            const month = parseInt(parts.find(part => part.type === 'month').value, 10);
            const day = parseInt(parts.find(part => part.type === 'day').value, 10);
            return { year, month, day };
        };
        const d1 = toKuwaitYMD(date1);
        const d2 = toKuwaitYMD(date2);
        const isSame = d1.year === d2.year && d1.month === d2.month && d1.day === d2.day;
        const isPrevious = d1.year < d2.year ||
            (d1.year === d2.year && d1.month < d2.month) ||
            (d1.year === d2.year && d1.month === d2.month && d1.day < d2.day);
        const result = isSame || isPrevious;
        
        console.log('🔍 isSameDay check:', { 
            date1: formatDateForLogs(date1),
            date2: formatDateForLogs(date2),
            d1Kuwait: d1,
            d2Kuwait: d2,
            result 
        });
        
        return result;
    }

    function isWithinRange(date, start, end) {
        const targetDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0));
        const startDate = new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate(), 12, 0, 0));
        const endDate = new Date(Date.UTC(end.getFullYear(), end.getMonth(), end.getDate(), 12, 0, 0));
        
        const result = targetDate >= startDate && targetDate <= endDate;
        console.log('📅 isWithinRange check:', { 
            targetDate: formatDateForLogs(targetDate), 
            startDate: formatDateForLogs(startDate), 
            endDate: formatDateForLogs(endDate), 
            result 
        });
        return result;
    }

    function isDateBlocked(date, selectedZoneId = null) {
        return false;
    }

    function parseYYYYMMDD(dateStr) {
        const parts = dateStr.split('-');
        if (parts.length !== 3) {
            console.error('❌ Invalid date format:', dateStr);
            return new Date();
        }
        
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const day = parseInt(parts[2], 10);
        
        return new Date(Date.UTC(year, month, day, 12, 0, 0));
    }

    function generateTimeSlotsForDate(selectedDate) {
        const timeSlotSelect = document.getElementById('time-slot-select');
        const timeSlotLabel = document.querySelector('[data-step="time"]').closest('.date-selector-label');
        const signatureContainer = document.querySelector('.signature-confirmation-container');
        const { timeWindows, timeSlots, defaultTimeSlot, slotDuration } = window.poojiDateGlobalConfig.localPickup;
        const now = new Date();
        const kuwaitFormatter = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Kuwait',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        const kuwaitParts = kuwaitFormatter.formatToParts(now);
        const kuwaitYear = parseInt(kuwaitParts.find(part => part.type === 'year').value, 10);
        const kuwaitMonth = parseInt(kuwaitParts.find(part => part.type === 'month').value, 10) - 1;
        const kuwaitDay = parseInt(kuwaitParts.find(part => part.type === 'day').value, 10);
        const kuwaitHour = parseInt(kuwaitParts.find(part => part.type === 'hour').value, 10);
        const kuwaitMinute = parseInt(kuwaitParts.find(part => part.type === 'minute').value, 10);
        const kuwaitToday = new Date(kuwaitYear, kuwaitMonth, kuwaitDay);
        const kuwaitNowMinutes = (kuwaitHour * 60) + kuwaitMinute;
        const selectedParts = selectedDate ? kuwaitFormatter.formatToParts(selectedDate) : null;
        const selectedYear = selectedParts ? parseInt(selectedParts.find(part => part.type === 'year').value, 10) : null;
        const selectedMonth = selectedParts ? parseInt(selectedParts.find(part => part.type === 'month').value, 10) : null;
        const selectedDay = selectedParts ? parseInt(selectedParts.find(part => part.type === 'day').value, 10) : null;
        const isSelectedToday = selectedParts &&
            selectedYear === kuwaitYear &&
            selectedMonth === (kuwaitMonth + 1) &&
            selectedDay === kuwaitDay;
        const isSelectedBeforeToday = selectedParts &&
            (selectedYear < kuwaitYear ||
                (selectedYear === kuwaitYear && selectedMonth < (kuwaitMonth + 1)) ||
                (selectedYear === kuwaitYear && selectedMonth === (kuwaitMonth + 1) && selectedDay < kuwaitDay));

        timeSlotSelect.innerHTML = `<option value="">${window.poojiDateGlobalConfig.textContent["time.slot.label"]}</option>`;

        const checkoutButtons = document.querySelectorAll('button[name="checkout"], input[name="checkout"], [form="cart"][name="checkout"], button#cart-checkout[data-href="/checkout"]');
        const dynamicCheckoutContainer = document.querySelector('.dynamic-checkout__content');
        
        checkoutButtons.forEach(button => {
            button.style.opacity = '0.5';
            button.style.pointerEvents = 'none';
        });

        if (dynamicCheckoutContainer) {
            dynamicCheckoutContainer.classList.remove('pooji-show');
        }

        if (!selectedDate) {
            timeSlotSelect.disabled = true;
            timeSlotLabel.classList.remove('enabled');
            return;
        }

        if (window.poojiDateGlobalConfig.autoSelectEarliestDate || document.querySelector('#ship-date').value) {
            timeSlotSelect.disabled = false;
            timeSlotLabel.classList.add('enabled');
        }
        
        const timeToMinutes = (timeStr, treatMidnightAs24 = false) => {
            if (!timeStr || typeof timeStr !== 'string') {
                return null;
            }
            const parts = timeStr.split(':');
            if (parts.length !== 2) {
                return null;
            }
            const hours = parseInt(parts[0], 10);
            const minutes = parseInt(parts[1], 10);
            if (Number.isNaN(hours) || Number.isNaN(minutes)) {
                return null;
            }
            if (treatMidnightAs24 && hours === 0 && minutes === 0) {
                return 24 * 60;
            }
            return (hours * 60) + minutes;
        };
        timeSlots.forEach(slot => {
            if (isSelectedBeforeToday) {
                return;
            }
            if (isSelectedToday) {
                const slotEndMinutes = timeToMinutes(slot.cutOff, true);
                if (slotEndMinutes !== null && kuwaitNowMinutes >= slotEndMinutes) {
                    return;
                }
            }
            const option = document.createElement('option');
            option.value = slot.label;
            option.textContent = slot.label;
            timeSlotSelect.appendChild(option);
        });

        const selectedTimeSlot = sessionStorage.getItem('timeSlot');
        if(selectedTimeSlot && selectedTimeSlot !== null) {
            timeSlotSelect.value = selectedTimeSlot;
        } else {
            timeSlotSelect.value = defaultTimeSlot;
        }
    }

    function initializeDatePicker() {
        let hideDatePicker = false;

        const dateSelector = document.querySelector('#date-selector-wrapper');
        const dateSelectorLabel = document.querySelector('.date-selector-label');

        // if (hideDatePicker) {
        //     console.log('Profile settings hide the date selector.');
        //     if (dateSelector) dateSelector.style.display = 'none';
        //     if (dateSelectorLabel) dateSelectorLabel.style.display = 'none';
        // } else {
        //     if (dateSelector) dateSelector.style.display = 'flex';
        //     if (dateSelectorLabel) dateSelectorLabel.style.display = 'flex';
        // }
        
        const datePickerBlock = document.querySelector('#delivery-time-slot-block');

        const config = {
            appendTo: datePickerBlock,
            animate: false,
            dateFormat: "d M Y",
            minDate: getMinimumDate(),
            maxDate: getLatestPossibleDate(),
            defaultDate: getMinimumDate(),
            locale: localeObject,
            nextArrow: '<svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M4 12L8 8M4 12L8 16" stroke="#5d5f62" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            prevArrow: '<svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M4 12L8 8M4 12L8 16" stroke="#5d5f62" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            disable: [
                function (date) {
                    if (!window.poojiDateGlobalConfig.availableDays) {
                        console.log('️ No available days config found, using defaults');
                        window.poojiDateGlobalConfig.availableDays = {
                            "monday": true,
                            "tuesday": true,
                            "wednesday": true,
                            "thursday": true,
                            "friday": true,
                            "saturday": true,
                            "sunday": true
                        };
                    }

                    if (!isLaterThanLatestEarliestAvailableDate(date)) {
                        return true;
                    }

                    const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                    const isDayAvailable = window.poojiDateGlobalConfig.availableDays[dayNames[date.getDay()]];

                    const dateKey = formatDateToYYYYMMDD(date);
                    const isBlocked = window.poojiDateGlobalConfig.blockedDates.some(blockedDate => {
                        if (blockedDate.type === 'individual') {
                            const blockDate = parseYYYYMMDD(blockedDate.date);
                            return isSameDay(blockDate, date);
                        } else if (blockedDate.type === 'range') {
                            const start = parseYYYYMMDD(blockedDate.start);
                            const end = parseYYYYMMDD(blockedDate.end);
                            return isWithinRange(date, start, end);
                        }
                        return false;
                    });

                    if (isCutoffPassed(date)) {
                        console.log(' Date disabled due to cutoff (no shipping profile):', formatDateForLogs(date));
                        return true;
                    }

                    const isDateBlockedForZone = isDateBlocked(date, null);

                    return !isDayAvailable || isDateBlockedForZone;
                }
            ],
            monthSelectorType: 'static',
            position: 'auto center',
            onChange: async function (selectedDates, dateStr, instance) {
                if (selectedDates.length > 0) {
                    console.log('📅 Selected delivery date:', JSON.stringify(selectedDates));
                    let deliveryDate = selectedDates[0];
                    document.querySelector("#ship-date").dataset.deliveryDate = deliveryDate;

                    generateTimeSlotsForDate(deliveryDate);
                    await updateCartItems();
                } else {
                    const surchargeEl = document.querySelector('.date-surcharge-display');
                    if (surchargeEl) {
                        surchargeEl.classList.remove('visible');
                    }
                }
            },
            onClose: function (selectedDates, dateStr, instance) {
                if (selectedDates.length === 0) {
                    document.querySelector('#ship-date').dataset.deliveryDate = undefined;
                }
            },
            onReady: function (selectedDates, dateStr, instance) {
                let defaultDate = getMinimumDate();
                if (defaultDate && window.poojiDateGlobalConfig.autoSelectEarliestDate) {
                    document.querySelector('#ship-date').dataset.deliveryDate = defaultDate.toISOString();
                    const isDateSaved = sessionStorage.getItem('deliveryDate');
                    if (isDateSaved) {
                        const savedDate = new Date(isDateSaved);
                        // Compare dates using getTime()
                        if (savedDate.getTime() >= defaultDate.getTime()) {
                            defaultDate = new Date(isDateSaved);
                        }
                    }
                    instance.setDate(defaultDate, true);
                }

                document.querySelector('.date-dropdown-arrow').classList.remove('hidden');
                generateTimeSlotsForDate(defaultDate);
            },
            onDayCreate: function (dObj, dStr, fp, dayElem) {
            },
        };

        if (flatpickrInstance) {
            flatpickrInstance.destroy();
        }

        flatpickrInstance = flatpickr("#ship-date", config);

        return flatpickrInstance;
    }

    initializeDatePicker();
    initializeTimeSlots();

    const datePickerBlock = document.querySelector('#delivery-time-slot-block');
    if (datePickerBlock) {
        datePickerBlock.classList.add('pooji-initialized');
        console.log('✅ Pooji block initialized and displayed.');
    } else {
        console.error('❌ Could not find #delivery-time-slot-block to display.');
    }
});
